module.exports = "data:image/png;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJpbWcvbG90dGVyeS1kZWZhdWx0LWhlYWRlci41NjQxMjE0NS5wbmciOw=="